import { churchesApi } from '../api/churchesApi'
import type { ChurchUpdateInput } from '../types/church'

export const updateChurch = async (church: ChurchUpdateInput) => {
  try {
    const { data } = await churchesApi.updateChurch(church)
    return data
  } catch (error) {
    console.error(`Error updating churches: `, error)
    throw error
  }
}
